module.exports = __webpack_public_path__ + "media/application/images/icons/instagram-783298771bb22c97d37c9b73ca7d86fb.svg";